export const dataLicitaciones = [
    /* {
        num: "1",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-01-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/1.pdf`, 
    },
    {
        num: "2",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-02-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/2.pdf`,
    },
    {
        num: "3",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-03-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/3.pdf`,
    },
    {
        num: "4",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-04-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/4.pdf`,
    },
    {
        num: "5",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-05-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/5.pdf`,
    },
    {
        num: "6",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-06-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/6.pdf`,
    },
    {
        num: "7",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-07-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/7.pdf`,
    },
    {
        num: "8",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-08-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/8.pdf`,
    },
    {
        num: "9",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-09-2025",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/9.pdf`,
    }, */
    {
        num: "1",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-01-2026",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/2026/1.pdf`,
    },
    {
        num: "2",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-02-2026",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/2026/2.pdf`,
    },
     {
        num: "3",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-03-2026",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/2026/3.pdf`,
    },
    {
        num: "4",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-04-2026",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/2026/4.pdf`,
    },
    {
        num: "5",
        nombreLicitacion: "LICITACIÓN PÚBLICA NACIONAL ITE-LP-05-2026",
        link: `https://itetlax.org.mx/assets/pdf/licitaciones/2026/5.pdf`,
    },
    
];

